import { BasePlate, BasePlateHeader } from '@evrone-erp/uikit';
import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { ReadOnlyInput } from './ReadOnlyInput';
export interface ILoginProps {
  login: string;
  onClick?(): void;
}
export const ReadOnlyCredentialsPlate = ({
  login,
  onClick
}: ILoginProps) => {
  const {
    t
  } = useTranslation('account');
  return <BasePlate pressable sx={{
    width: '100%',
    height: '100%'
  }} onClick={onClick}>
      <BasePlateHeader title={t('credentials')} sx={{
      mb: '40px'
    }} />
      <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '25px'
    }}>
        <ReadOnlyInput type="text" id="login-input" label={t('login')} value={login} />
        <ReadOnlyInput id="dummy-password-input" label={t('password')} type="password"
      // dummy value to show points on screen
      value="dummy-pass" />
      </Box>
    </BasePlate>;
};